import { render, staticRenderFns } from "./AreaPlans.vue?vue&type=template&id=5d05fa93&"
import script from "./AreaPlans.vue?vue&type=script&lang=js&"
export * from "./AreaPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d05fa93')) {
      api.createRecord('5d05fa93', component.options)
    } else {
      api.reload('5d05fa93', component.options)
    }
    module.hot.accept("./AreaPlans.vue?vue&type=template&id=5d05fa93&", function () {
      api.rerender('5d05fa93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AreaPlans.vue"
export default component.exports